exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.admin-logo-custom {\n  width: 120px;\n  margin-top: 15px !important;\n}\n\ndiv.menu-toggler-custom {\n    margin-top: 20px !important;\n}\n.position-fixed{\n    position: fixed;\n}\n\n@media (min-width: 992px){\n    .page-sidebar-closed .page-sidebar .page-sidebar-menu.page-sidebar-menu-closed>li:hover {\n            width: 45px !important;\n            box-shadow: none !important;\n    }\n    .page-sidebar-closed .page-sidebar .page-sidebar-menu.page-sidebar-menu-closed>li:hover>a>.title {\n            display: none !important;\n    }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/dashboard/dashboard.component.css
// module id = 585
// module chunks = 0